<template>
  <div class="w-100">
    <Header/>
    <b-spinner variant="info" label="spinner" v-if="detalleOdt === null" style="margin-top: 10%"></b-spinner>
    <StepperEtapas v-if="detalleOdt !== null" :etapaActual="Number(idEtapa)" style="margin-top: 1% !important;" :etapasLaboratorio="detalleOdt.etapasLaboratorio" :es-flujo-digital="detalleOdt.idTipoFlujoFisico === null"/>
    <b-row style="margin-top: 1% !important;" class="align-items-start" v-if="detalleOdt !== null">
      <b-col class="m-0">
        <div class="text-left p-3 pt-2 pb-2" :class="{'scrollable-container-odt': comentarios == true }" style="min-height: 85vh; background-color: white;  border-radius: 10px;">
          <div class="d-flex justify-content-between">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <em class="left_arrow mr-2" style="cursor: pointer;" @click="volverAtras()"></em>
                <p class="m-0 title-odt">Orden de trabajo No. {{this.$route.params.idOdt}}</p>
              </div>
              <p class="ml-4 mt-1 mb-1" style="font-size: .8em;" v-if="detalleOdt && detalleOdt.fechaCreacion != null">{{ detalleOdt.fechaCreacion | formatoFechaHora }}</p>
              <p class="ml-4 mt-1 subtitle" style="font-size: .8em;"> Laboratorio: {{ detalleOdt.nombreLaboratorio }}</p>
            </div>
            <div class="d-flex align-items-center position-relative">
              <div v-if="detalleOdt.fechaEstimada !== null && !detalleOdt.etapasLaboratorio.some(etapa => etapa.idEtapaProceso === 108) " class="mr-2">
                <span v-if="!detalleOdt.progreso" class="delayed-chip " style="width: 90px; display: flex;justify-content: center;"
                      v-b-tooltip.hover.righttop.v-light :title="`Este producto tiene ${detalleOdt.diasRetraso} días de retraso`">
                  Retrasado
                </span>
                <span v-else class="intime-chip " style="width: 90px; display: flex;justify-content: center;"
                      v-b-tooltip.hover.righttop.v-light title="Este producto va en tiempo">
                  En tiempo
                </span>
              </div>
              <div class="row mr-2" v-if="idEtapa == 112 || idEtapa == 113 || idEtapa == 114">
                <div>
                  <span class="cancelation-chip" style="width: 200px; display: flex;justify-content: center;">
                    Cancelación solicitada
                  </span>
                </div>
              </div>
              <div v-if="(idEtapa == 108) && (detalleOdt.odtCancelada == true)">
                <span class="cancelation-success mr-3" style="width: 95px; display: flex;justify-content: center;">
                    Cancelada
                </span>
              </div>
              <em v-if="!comentarios" class="comments icons-size" v-b-tooltip.hover.righttop.v-light title="Ver comentarios" @click="verComentarios()">
              </em>
              <span v-if="!comentarios && detalleOdt.noComentarios > 0" class="numberComentarios">{{detalleOdt.noComentarios}}</span>
            </div>
          </div>
          <div v-if="detalleOdt.rechazo !== null">
            <div class="row ml-4 mr-1 mt-2" v-if="detalleOdt.rechazo !== null">
              <p style="color: #DE6F6F">Motivo del rechazo (Laboratorio) - {{detalleOdt.rechazo.fechaRechazo | formatoFecha}}: </p> {{detalleOdt.rechazo.motivoRechazo}}
            </div>
            <div class="ml-4 mr-1 mt-4" v-if="detalleOdt.rechazo !== null">
              <p style="color: #DE6F6F">Comentarios del rechazo (Laboratorio) - {{detalleOdt.rechazo.fechaRechazo | formatoFecha}}: </p> {{detalleOdt.rechazo.observaciones}}
            </div>
            <div class="ml-4 mr-1 mt-4" v-if="detalleOdt.continuaDental !== null">
              <p style="color: #DE6F6F">Comentarios de la continuacion (Clinica) - {{detalleOdt.continuaDental.fechaContinuaDental | formatoFecha}}: </p> {{detalleOdt.continuaDental.observacionesDental}}
            </div>
            <hr>
          </div>
          <EnvioRecoleccion v-if="detalleOdt.idTipoFlujoFisico !== null && paqueterias !== null && (!detalleOdt.tieneDatosEnvio || editarDatosEnvio) && idEtapa == 103" :paqueterias="paqueterias" :datosOdt="detalleOdt" :editarDatosEnvio="editarDatosEnvio" @editarEnvio="editarEnvio"/>
          <div class="ml-4 mr-1 mt-4">
            <p class="subtitle">Información general</p>
            <b-row class="mt-2">
              <b-col cols="12" md="12" lg="9" xl="9">
                <b-row class="p-0">
                  <b-col cols="4" md="4" lg="4" xl="4" style="line-height: 2.4; word-wrap: break-word;">
                    <p v-if="detalleOdt && detalleOdt.clinica != null"><span class="fontMedium">Clínica: </span>{{detalleOdt.clinica}}</p>
                    <p class="word-wrap"><span class="fontMedium">Doctor:</span> {{ detalleOdt.doctor }}</p>
                    <p><span class="fontMedium">Paciente: </span>{{detalleOdt.nombrePaciente }}</p>
                  </b-col>
                  <b-col cols="4" md="4" lg="4" xl="4" style="line-height: 2.4">
                    <p><span class="fontMedium">Producto: </span> {{ detalleOdt.producto}}</p>
                    <p><span class="fontMedium">Tratamiento: </span> {{ detalleOdt.tratamiento }}</p>
                    <p>
                      <span class="fontMedium">Cantidad: </span>
                      {{ dientesOdt.length }}
                      <span v-if="dientesMostrar.length > 0">
                        (<template v-if="dientesOdt.some(d => d.numeroDiente !== 0)">Órgano dental </template>{{ dientesMostrar.join(', ') }})
                      </span>
                    </p>
                  </b-col>
                  <b-col cols="4" md="4" lg="4" xl="4" style="line-height: 2.4" v-if="!detalleOdt.tieneDatosEnvio">
                    <p><span class="fontMedium">Flujo: </span> {{ detalleOdt.flujo }} </p>
                    <p><span class="fontMedium">Tipo de ODT: </span> {{ detalleOdt.tipoDeOdt }}</p>
                  </b-col>
                  <b-col cols="4" md="4" lg="4" xl="4" style="line-height: 2.4" v-else-if="detalleOdt.tieneDatosEnvio && detalleOdt.datosEnvioOdt.idPaqueteria != null">
                    <p><span class="fontMedium">Tipo de ODT: </span> {{ detalleOdt.tipoDeOdt }}</p>
                    <p><span class="fontMedium">Paqueteria: </span> {{ detalleOdt.datosEnvioOdt.nombrePaqueteria }}
                    <b-button variant="outline-warning" v-if="idEtapa == 103" @click="mostrarEdicionEnvio()" size="sm"><b-icon icon="pencil-square"></b-icon></b-button></p>
                    <p><span class="fontMedium">No. de seguimiento: </span> {{ detalleOdt.datosEnvioOdt.noSeguimiento }}</p>
                  </b-col>
                  <b-col cols="4" md="4" lg="4" xl="4" style="line-height: 2.4" v-else-if="detalleOdt.tieneDatosEnvio && detalleOdt.datosEnvioOdt.mensajero != null">
                    <p><span class="fontMedium">Tipo de ODT: </span> {{ detalleOdt.tipoDeOdt }}</p>
                    <p><span class="fontMedium">Nombre de quien recogio: </span> {{ detalleOdt.datosEnvioOdt.mensajero }}</p>
                    <p><span class="fontMedium">Hora de recolección: </span> {{ detalleOdt.datosEnvioOdt.horaRecoleccion | formatoHoraDeEntero }} {{detalleOdt.datosEnvioOdt.horaRecoleccion > 1200 ? 'p.m.' : 'a.m.'}}</p>
                  </b-col>
                </b-row>

              </b-col>
              <b-col cols="12" md="3" lg="3" xl="3" class="text-center">
                <b-img
                    :src="require('@/assets/ImgLogo_azul.png')"
                    alt="logo_dentalia"
                    class="logoDent"
                ></b-img>
              </b-col>
            </b-row>
          </div>

          <div class="m-4 text-left textSize">
            <p class="subtitle">Detalles del trabajo</p>
                    <!--   DEPENDIENDO DE CADA FLUJO O VARIANTE       -->
                    <!--  Detalle Flujo Fisico      -->
                    <DetalleFlujoDigital v-if="detalleOdt !== null && detalleOdt.archivosLaboratorios.length > 0 && detalleOdt.idTipoFlujoFisico == null"
                                         :listaDocumentos="detalleOdt.archivosLaboratorios" :detalle-info="detalleOdt"/>
          
                    <DetalleProtesis v-if="detalleOdt !== null && (detalleOdt.idTipoFlujoFisico === 1 || detalleOdt.idTipoFlujoFisico === 2 ) && protesis !== null"
                                     :protesisProp="protesis" />
          
                    <DetalleGuarda v-if="detalleOdt !== null && detalleOdt.idTipoFlujoFisico === 4 " :datos-guarda="detalleOdt.guarda"/>
          
                    <DetalleOrtodonciaOrtopedia v-if="detalleOdt !== null && detalleOdt.idTipoFlujoFisico === 3 && paqueterias !== null" :datosOdt="detalleOdt.ortodoncia" :paqueterias="paqueterias"/>
          
                  </div>
          
                  <div class="m-4 text-left textSize">
                    <VisualizadorArchivos v-if="detalleOdt != null && (detalleOdt.idTipoFlujoFisico !== null && detalleOdt.archivosLaboratorios.length > 0)" :listaDocumentos="detalleOdt.archivosLaboratorios" :comentarios="comentarios"/>
                  </div>
          
                  <div class="m-4 text-left textSize">
                    <p><span style="font-weight: 600;">Observaciones: </span>{{detalleOdt.observaciones}}</p>
                  </div>

                  <b-row v-if="idEtapa == 109">
                    <b-col align="right"><b-button v-if="$localStorageService.can('lab_recz_conti_calidad')" @click="continuarOdt(true)" variant="outline-info" pill style="background: #0155A7; color: aliceblue">Continuar a calidad</b-button></b-col>
                    <b-col align="left"><b-button v-if="$localStorageService.can('lab_recz_no_conti_calidad')" @click="continuarOdt(false)" pill>No continuar a calidad</b-button></b-col>
                  </b-row>

                  <b-row v-if="idEtapa == 110">
                    <b-col align="right"><b-button v-if="$localStorageService.can('lab_recz_conti_prod')" @click="continuarOdt(true)" variant="outline-info" pill style="background: #0155A7; color: aliceblue">Continuar a Producción</b-button></b-col>
                    <b-col align="left"><b-button v-if="$localStorageService.can('lab_recz_no_conti_prod')" @click="continuarOdt(false)" pill>No continuar a Producción</b-button></b-col>
                  </b-row>
        </div>
        <div v-if="$localStorageService.can('BT_cancelar_odt') && (idEtapa == 112 || idEtapa == 113 || idEtapa == 114)">
          <b-button variant="outline-info" pill style="background: #0155A7; color: aliceblue" size="sm" class="mb-3" @click="cancelarOdt()">
            <span>Aceptar cancelación</span>
          </b-button>
        </div>
      </b-col>
      <b-col v-if="comentarios" class="m-0 comentarios-container" cols="4">
        <div class=" text-left" style="height: 102vh; background-color: white;  border-radius: 10px; padding: 2%;">
          <em class="close" @click="comentarios = false"></em>
          <p class="subtitle mt-3 mb-3">Comentarios</p>
          <VistaChat :idClinica="detalleOdt.idClinica" :idLaboratorio="detalleOdt.idLaboratorio" :ruta="rutaBaseArchivos" />
        </div>
      </b-col>
    </b-row>

          <b-modal 
            v-model="modalPruduccion"
            title="Continuar con producción del producto"
            size="lg"
            hide-footer no-close-on-backdrop
            v-if="detalleOdt !== null && detalleOdt.rechazo !== null"
            hide-header
          >
            <ModalContinuarProduccion @cerrarModalRechazos="cerrarModalRechazos" :idODT="Number(this.$route.params.idOdt)" :idOdtRechazo="detalleOdt.rechazo.idOdtRechazo" :producto="detalleOdt.producto"/>
          </b-modal>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import DetalleProtesis from "@/views/LaboratorioV2/OrdenTrabajoPaciente/DetalleProtesis.vue";
import DetalleGuarda from "@/views/LaboratorioV2/OrdenTrabajoPaciente/DetalleGuarda.vue";
import VisualizadorArchivos from "@/views/LaboratorioV2/OrdenTrabajoPaciente/VisualizadorArchivos.vue";
import DetalleFlujoDigital from "@/views/LaboratorioV2/OrdenTrabajoPaciente/DetalleFlujoDigital.vue";
import DetalleOrtodonciaOrtopedia from "./DetalleOrtodonciaOrtopedia.vue";
import EnvioRecoleccion from "./EnvioRecoleccion.vue";
import ModalContinuarProduccion from "@/views/LaboratorioV2/OrdenTrabajoPaciente/ModalContinuarProduccion.vue";
import StepperEtapas from "./StepperEtapas.vue";
import VistaChat from "./VistaChat.vue";
export default {
  name: "DetalleOdtPaciente",
  components: {DetalleFlujoDigital, DetalleProtesis, Header, DetalleGuarda, VisualizadorArchivos, DetalleOrtodonciaOrtopedia, EnvioRecoleccion,ModalContinuarProduccion,StepperEtapas,VistaChat},
  data() {
    return{
      detalleOdt: null,
          protesis: null,
          paqueterias: null,
          modalPruduccion: false,
          datosRechazo: {
            observaciones: null
          },
          comentarios: false,
          idEtapa: null,
      editarDatosEnvio: false,
      rutaBaseArchivos: null,
      dientesOdt: [],
      dientesMostrar: [],
      etapaAnterior: null,
    }
  },
 created(){
 this.obtenerDetalleOdt();
 this.obtenerRutaODT();
 this.idEtapa = this.$route.params.idEtapa;
 },
  methods: {
    verComentarios(){
      this.comentarios = true;
    },
    volverAtras() {
      window.history.back();
    },    
        rechazarProduccion(){
          this.$swal({
            title: 'Rechazar producción',
            text: `El producto "${this.detalleOdt.producto}" no continuará su producción con el laboratorio, ¿deseas continuar?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar'
          }).then((result) => {
            if (result.isConfirmed) {
              //aqui se guarda
              const params = {
                idSolicitud: this.$route.params.idSolicitud,
                idEtapa: this.$route.params.idEtapa,
                retorno: false,
                rechazo: false,
                continua: false,
                idOdtLaboratorio: this.$route.params.idOdt,
                idAccion: this.$route.params.idEtapa === 109 ? 55 : 57,
              }
              this.$http.post(this.$api + "labs/odt/siguienteEtapa", params).then(response => {
                if (response.data.data) {
                  this.$swal({
                    title: 'Cancelación de producción del producto',
                    text: 'El laboratorio no continuará con la producción',
                    icon: 'success',
                    showCancelButton: true,
                    cancelButtonText: 'Cerrar'
                  });
                  window.history.back();
                }
              }).catch((err) => {
                this.$swal.fire({
                  icon: "error",
                  title: "Aviso",
                  text: "Ocurrió un error",
                });
                console.info(err)
              });
            }
          });
        },

        mostrarEdicionEnvio(){
          this.editarDatosEnvio = !this.editarDatosEnvio;
        },
        
        abrirModalProduccion(){
          this.modalPruduccion = true;
        },
    
        cerrarModalRechazos(){
          this.modalPruduccion = false;
          //this.$router.go(0);
        },
    
        obtenerDetalleOdt(){
          const params = {
            idOdt: this.$route.params.idOdt,
          }
          this.$http.post(this.$api + "labs/odt/obtenerDetalle", params).then(response => {
            if (response.data.data) {
              this.detalleOdt = response.data.data;
              if (this.detalleOdt !== null){
                this.protesis = this.detalleOdt.protesis
                this.dientesOdt = this.detalleOdt.listaCantidadDientes
                const numeros = this.dientesOdt
                    .map(d => d.numeroDiente)
                    .filter(n => n !== 0)
                    .sort((a, b) => a - b);

                const nombres = this.dientesOdt
                    .filter(d => d.numeroDiente === 0)
                    .map(d => d.nombreDiente);

                this.dientesMostrar = [...numeros, ...nombres];
              }
            }
          }).finally(()=>{
            if(this.detalleOdt.idTipoFlujoFisico !== null){
              this.obtenerPaqueterias();
            }
          })
        },
        obtenerPaqueterias(){
          this.$http.post(this.$api + "labs/odt/obtenerPaqueterias").then(response => {
            if (response.data.data) {
              this.paqueterias = response.data.data;
            }
          })
        },
        editarEnvio(){
          this.editarDatosEnvio = false;
        },

    continuarOdt(continua){
      if(continua){
        this.abrirModalProduccion();
      }else{
        this.rechazarProduccion();
      }
    },

    obtenerRutaODT(){
      this.$http.get(this.$api + "rutaExpediente/rutaODT")
          .then((response) => {
            this.rutaBaseArchivos = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },

    cancelarOdt(){
      const params = {
        idSolicitud: this.$route.params.idSolicitud,
        idEtapa: this.$route.params.idEtapa,
        retorno: false,
        rechazo: false,
        continua: false,
        idOdtLaboratorio: this.$route.params.idOdt,
        idAccion: 64,
      }
      this.$http.post(this.$api + "labs/odt/siguienteEtapa", params).then(response => {
        if (response.data.data) {
          window.history.back();
        }
      }).catch((err) => {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Ocurrió un error",
        });
        console.info(err)
      });
    },
  }
};
</script>

<style>
p{
  font-size: .85em;
}
.logoDent {
  width: 100%;
  max-width: 90px;     
}
.comentarios-container {
  display: flex;
  flex-direction: column;
  height: 100%; 
  max-height: calc(100vh - 100px); 
}

.title-odt{
  font-weight: 600;
  font-size: 1.1em;
  color: #002347;
}

.subtitle{
  font-weight: 600;
  font-size: .95em;
  color: #0155A7;
}

.delayed-chip{
  box-sizing: border-box;
  display: inline-block;
  color: #FF7700;
  background-color: #FFEBDC;
  border-radius: 20px;
  padding: 1% 2% 1% 2%;
  width: 70%;
  font-size: .9em;
}

.intime-chip{
  box-sizing: border-box;
  display: inline-block;
  color: #26853F;
  background-color: #EAFFEA;
  border-radius: 20px;
  padding: 1% 2% 1% 2%;
  width: 70%;
  font-size: .9em;
}

.cancelation-chip{
  box-sizing: border-box;
  display: inline-block;
  color: #f0a83f;
  background-color: #fff9db;
  border-radius: 20px;
  padding: 1% 2% 1% 2%;
  width: 70%;
  font-size: .9em;
}


.scrollable-container-odt {
  overflow-y: auto;
  max-height: 98vh;
}

.word-wrap {          /* nuevo helper */
  word-break: break-word;
  white-space: normal;
}

.numberComentarios {
  width: 15px;
  height: 15px;
  position: absolute;
  background: white;
  right: -2px;
  bottom: 30px;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-color: var(--color-dentalia);
  color: var(--color-dentalia-v2);
  border: solid 1px;
  font-weight: 600;
}

.cancelation-success{
  box-sizing: border-box;
  display: inline-block;
  color: #B61515FF;
  background-color: #fdcece;
  border-radius: 20px;
  padding: 1% 2% 1% 2%;
  width: 70%;
  font-size: .9em;
}
</style>
